import script from "./LoginPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginPage.vue?vue&type=script&lang=ts&setup=true"

import "./LoginPage.vue?vue&type=style&index=0&id=0143db56&lang=scss"

const __exports__ = script;

export default __exports__